<template>
  <v-main style="background-color: transparent">
    <v-container class="pa-4">
      <v-row no-gutters class="mb-6">
        <v-col cols="1">
          <gradient-bar />
        </v-col>
        <v-col cols="12">
          <h6
            class="primary--text font-weight-bold text-uppercase mt-4"
            style="letter-spacing: 1px"
          >
            Pitch Connect
          </h6>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-12">
        <v-col cols="12" md="6" class="pr-md-10">
          <h2
            class="gradient-text text-h3 font-weight-black mb-6"
            style="line-height: 1.2"
          >
            A conexão certa para alcançar seus objetivos!
          </h2>
          <p class="poppins body-text">
            Na Pitch, acreditamos que o aprendizado acontece quando há
            alinhamento. por isso criamos um processo que
            <strong>conecta alunos aos professores certos</strong>, considerando
            <strong
              >objetivos, perfis, modalidade de aula e metodologia.</strong
            >
          </p>
          <p class="poppins body-text">
            Para quem aprende, isso significa
            <strong
              >aulas personalizadas, flexibilidade e economia financeira e de
              tempo.</strong
            >

            Para quem ensina, significa
            <strong>autonomia e estrutura tecnológica e metodológica</strong>
            para a melhor experiência online de aula possível!
          </p>
        </v-col>

        <v-col cols="12" md="6">
          <v-card
            outlined
            color="rgba(0,0,0,0.05)"
            class="pa-6 d-flex flex-column justify-center"
            style="
              min-height: 280px;
              border-radius: 20px;
              border: 1px solid rgba(153, 35, 205, 0.2);
            "
          >
            <v-window v-model="activeStep" vertical>
              <v-window-item v-for="(step, i) in processSteps" :key="i">
                <div class="text-center text-md-left">
                  <v-icon color="primary" size="48" class="mb-4">{{
                    step.icon
                  }}</v-icon>
                  <h4 class="primary--text text-h5 font-weight-bold mb-3">
                    {{ step.title }}
                  </h4>
                  <p
                    class="grey--text text--darken-2 mb-0"
                    style="font-size: 1.1rem"
                  >
                    {{ step.description }}
                  </p>
                </div>
              </v-window-item>
            </v-window>

            <div class="d-flex justify-center justify-md-start mt-6">
              <v-btn
                v-for="(step, i) in processSteps"
                :key="'dot' + i"
                icon
                x-small
                :color="activeStep === i ? 'primary' : 'grey lighten-1'"
                @click="activeStep = i"
              >
                <v-icon>mdi-circle</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(benefit, index) in benefits"
          :key="index"
          cols="12"
          sm="6"
          class="pa-4"
        >
          <v-card flat color="transparent" class="h-100">
            <v-row no-gutters align="start">
              <v-col cols="auto" class="mr-4">
                <v-icon color="primary" x-large size="32">{{
                  benefit.icon
                }}</v-icon>
              </v-col>
              <v-col>
                <h5 class="primary--text font-weight-bold text-h6 mb-2">
                  {{ benefit.title }}
                </h5>
                <div class="poppins body-text" v-html="benefit.text"></div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "DiferentialPage",
  data: () => ({
    activeStep: 0,
    carouselInterval: null,
    processSteps: [
      {
        title: "1. Conte seus objetivos",
        description:
          "Você preenche um formulário rápido informando seu objetivo com o inglês, seu perfil e disponibilidade de horários.",
        icon: "mdi-form-select",
      },
      {
        title: "2. Análise inteligente",
        description:
          "A plataforma analisa suas informações e cruza com a base de professores disponíveis alinhado ao que você busca.",
        icon: "mdi-brain",
      },
      {
        title: "3. O professor ideal em contato",
        description:
          "O professor mais alinhado entra em contato com você para apresentar horários, valores e como funciona a metodologia.",
        icon: "mdi-account-heart",
      },
      {
        title: "4. Conexão validada antes de começar",
        description:
          "Você garante que a conexão com o professor faz sentido antes de iniciar as aulas, com clareza e segurança.",
        icon: "mdi-handshake",
      },
    ],
    benefits: [
      {
        icon: "mdi-chat",
        title: "2 aulas de conversação em grupo gratuitas",
        text: "Além das aulas com o seu professor ideal, você tem acesso duas aulas de conversação e uma monitoria semanal <strong>gratuitamente.</strong> Tudo para você poder ter uma <strong>imersão na língua!</strong>",
      },
      {
        icon: "mdi-cellphone",
        title: "Aplicativo Pitch",
        text: "No nosso <strong>aplicativo</strong> você acessa<strong> todos os materiais, jogos, exercícios</strong> e links das <strong>aulas de conversação</strong> de forma rápida na palma da sua mão.",
      },
      {
        icon: "mdi-format-color-text",
        title: "Material didático exclusivo e gratuito",
        text: "Você terá acesso a todo os materiais e recursos do Pitch elaborados a partir da <strong>metodologia internacional Conversation Experience sem pagar nada</strong a mais por isso.",
      },
      {
        icon: "mdi-controller",
        title: "Recursos Extras",
        text: "Como aluno, você terá acesso a mais de <strong>64 vídeo aulas, guias de estudos completos e exercícios para testes de proficiência</strong> para fortalecer seu aprendizado fora de aula.",
      },
    ],
  }),
  mounted() {
    this.carouselInterval = setInterval(() => {
      this.activeStep = (this.activeStep + 1) % this.processSteps.length;
    }, 8000);
  },
  beforeDestroy() {
    clearInterval(this.carouselInterval);
  },
};
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(90deg, #e8276f, #9923cd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.shadow-soft {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
}

.poppins {
  font-family: "Poppins", sans-serif !important;
  line-height: 1.6;
}

.body-text {
  color: #5f5f61;
  font-size: 1.1rem;
}
</style>
